const styles = {
  date: {
    display: "flex",
  },
  placeholder: {
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 199,
    width: "100%",
    height: "100vh",
    backgrondColor: "transparent",
    opacity: 1,
  },
};

export default styles;
